import { CharterSubtype, CharterType } from "__generated__/enums";
import { CreateOrExistingPurchaseCharterForm } from "view/charters/components/form/useCreateOrExistingCharterFormFields";
import { toFormRelation } from "utils/relationUtils";
import { DateUtils } from "utils/DateUtils";
import { Ship } from "view/ships/types/ship";
import { Relation } from "view/relations/types/relation";

export const getCharterTypeColor = (type: CharterType, subtype?: CharterSubtype) => {
	switch (type) {
		case CharterType.Sales: {
			if (!subtype) {
				return "#45B741";
			}
			switch (subtype) {
				case CharterSubtype.Spot:
					return "#6da8a6";
				case CharterSubtype.Time:
					return "#52434e";
				case CharterSubtype.Contract:
					return "#f6a75e";
				case CharterSubtype.Supplier:
					return "#9a5b49";
				default:
					return "#dddddd";
			}
		}
		case CharterType.Purchase: {
			if (!subtype) {
				return "#FF0000";
			}
			switch (subtype) {
				case CharterSubtype.Spot:
					return "#4b678a";
				case CharterSubtype.Time:
					return "#90728a";
				case CharterSubtype.Contract:
					return "#da7245";
				case CharterSubtype.Supplier:
					return "#9a5b49";
				default:
					return "#dddddd";
			}
		}
	}
};

export const getCharterSubtypeColor = (option: CharterSubtype) => {
	switch (option) {
		case CharterSubtype.Supplier:
			return "#a66c5a";
		case CharterSubtype.Time:
			return "#90728a";
		case CharterSubtype.Contract:
			return "#f6a75e";
		case CharterSubtype.Spot:
			return "#6da8a6";
		default:
			return "#dddddd";
	}
};

export const determineAutomaticCreditor = (ship?: Pick<Ship, "id" | "owner"> & { operator?: Pick<Relation, "id" | "applicationRelation"> | null }) => {
	if (ship?.operator && !ship.operator.applicationRelation) {
		return toFormRelation(ship.operator);
	} else if (ship?.owner) {
		return toFormRelation(ship.owner);
	} else {
		return null;
	}
};

export const determineCharterValidity = (charter: CreateOrExistingPurchaseCharterForm["charter"]): [ number | null, number | null ] | [ undefined, undefined ] => {
	if (charter.subtype === "EXISTING") {
		if (charter.existing?.type === CharterType.Purchase && charter.existing.subtype === CharterSubtype.Time) {
			return [
				DateUtils.getTimestamp(charter.existing.validFrom),
				DateUtils.getTimestamp(charter.existing.validUntil),
			];
		}
	} else if (charter.type === CharterType.Purchase && charter.subtype === CharterSubtype.Time) {
		return [
			DateUtils.getTimestamp(charter.new?.contract?.isParentContract ? charter.new.contract.validFrom : charter.new?.validBetween?.[0]),
			DateUtils.getTimestamp(charter.new?.contract?.isParentContract ? charter.new.contract.validUntil : charter.new?.validBetween?.[1]),
		];
	}
	return [ undefined, undefined ];
};
